import { render, staticRenderFns } from "./titleAdmin.vue?vue&type=template&id=db264d94&scoped=true&"
import script from "./titleAdmin.vue?vue&type=script&lang=js&"
export * from "./titleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./titleAdmin.vue?vue&type=style&index=0&id=db264d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db264d94",
  null
  
)

export default component.exports